const getRootMasterplans = masterplans => {
  let rootMasterplans = []
  if (masterplans)
    masterplans.forEach(item => {
      if (item.parentId === 0) {
        rootMasterplans.push(item)
      }
    })
  return rootMasterplans
}

// Builds a depth-first, depth-annotated masterplan option list from a flat
// array of { id, name, parentId }, so a <v-select> can render parent/child
// relationships as a visually indented tree instead of a flat list ordered
// however the API happened to return it. `rootId` (falsy/0 for "top of the
// project", same root sentinel as getRootMasterplans above), when given,
// scopes the tree to just that node's own descendants — depth 0 becomes its
// direct children, not the project's top-level masterplans — which is how
// a masterplan's own fall-through picker stays limited to its own subtree.
const buildMasterplanTreeOptions = (masterplans, rootId = 0) => {
  const byParent = new Map()
  ;(masterplans || []).forEach(m => {
    const key = m.parentId || 0
    if (!byParent.has(key)) byParent.set(key, [])
    byParent.get(key).push(m)
  })
  const options = []
  const walk = (parentId, depth) => {
    const children = byParent.get(parentId) || []
    children.forEach(m => {
      options.push({ id: m.id, name: m.name, parentId: m.parentId, depth })
      walk(m.id, depth + 1)
    })
  }
  walk(rootId, 0)
  return options
}

export default {
  getRootMasterplans,
  buildMasterplanTreeOptions
}
